import React from 'react';
import { Button } from 'antd';

interface CopyInfoButtonProps {
  onClick: () => void | Promise<void>;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const CopyInfoButton: React.FC<CopyInfoButtonProps> = ({ onClick, children = '复制信息', className, style }) => {
  return (
    <Button
      type="primary"
      className={`copy-info-btn ${className || ''}`}
      style={{
        backgroundColor: '#f97316', // Tailwind orange-500
        borderColor: '#ea580c',     // Tailwind orange-600
        color: '#fff',
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default CopyInfoButton;


